import { render, staticRenderFns } from "./TabDropdown.vue?vue&type=template&id=1f99c330&scoped=true&"
import script from "./TabDropdown.vue?vue&type=script&lang=js&"
export * from "./TabDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TabDropdown.vue?vue&type=style&index=0&id=1f99c330&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f99c330",
  null
  
)

export default component.exports